<template>
  <div @click="toggleFilter()">
      <div v-if="window.size.desktop"
           class="z-backdrop fixed left-0 top-0 w-full h-full outline-none !bg-black/40"
           @click.stop="toggleFilter(); unblockScrolling(); clearFilters()">
      </div>
      <div @click.stop=""
           class="fixed filter-panel filter-panel-scroll w-screen top-0 left-0 right-0 bg-zt-normal bottom-0 space-y-4 rounded-zt shadow-zt z-[900]
             xl:w-[624px] xl:h-fit xl:left-0 xl:max-w-[unset] xl:absolute xl:top-[125%] xl:overflow-visible xl:translate-x-0 xl:translate-y-0 xl:z-modal"
           :class="[
             { 'filter-panel': window.size.desktop },
             { '!rounded-tl-[0px]': window.size.desktop },
             { 'top-8 h-[calc(100%-32px)]': userCanAddCommentTypeBet && window.size.mobile },
             { 'h-full': !userCanAddCommentTypeBet && window.size.mobile }
           ]">
        <div class="flex items-center border-b border-zt-light pl-4 pr-3.5 h-[55px] gap-4 xl:gap-5">
          <span class="text-xl font-medium">Filtrowanie</span>
          <span class="text-sm font-medium"
                :class="selectedFilterCategoryCount || !(odds.min === 0 && odds.max === 999) || showOnlyFollowedUsers ||
                  showOnlyNotPlayedYet ? 'text-zt-red cursor-pointer zt-hover' : 'opacity-20'"
                @click.stop="clearFilters()">Wyczyść filtry</span>
          <div v-if="window.size.mobile" class="x-close-modal"
               @click.stop="toggleFilter(); unblockScrolling(); filterBets(true)"></div>
        </div>
        <div class="flex flex-col gap-4 overflow-x-hidden overflow-y-auto !mt-0 pt-4 h-[calc(100%-55px)] xl:h-fit">
          <div class="flex-1 -mt-4 mx-5">
            <div class="text-xl font-medium mt-2.5 mb-2.5 xl:text-base xl:mt-[15px] xl:mb-3 xl:font-semibold">Dyscypliny:</div>
            <div class="grid  grid-cols-2 text-sm gap-y-[15px] xl:text-base xl:grid-cols-2 xl:gap-y-2.5 xl:gap-x-10">
              <div class="flex items-center gap-[7px] zt-hover cursor-pointer"
                   title="Wszystkie"
                   @click.stop="toggleDiscipline('all')">
                <svg width="25" height="25" class="w-5 h-5 xl:h-[25px] xl:w-[25px]" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :fill="disciplineAllSelected ? '#FF4A5D' : '#3A4B6459'" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.38985 15.9466L5.30791 12.2349L3.94727 13.4721L9.38985 18.4211L21.0525 7.81621L19.6919 6.57898L9.38985 15.9466Z"
                        :fill="disciplineAllSelected ? 'white' : 'transparent'" />
                  <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :stroke="disciplineAllSelected ? '#9B2733' : '#3A4B64'" />
                </svg>
                <div class="flex items-center gap-1 font-normal text-[#EEE]">
                  <span>Wszystkie</span>
                  <span class="font-light">({{ allBetsCount }})</span>
                </div>
              </div>
              <div v-for="(discipline, index) in disciplines" :key="discipline.title"
                   class="flex items-center gap-[7px] font-normal cursor-pointer zt-hover text-[#EEE] xl:min-w-[200px]"
                   @click.stop="toggleDiscipline(discipline)">
                <svg width="25" height="25" class="w-5 h-5 xl:h-[25px] xl:w-[25px]" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :fill="discipline.search && !disciplineAllSelected ? '#FF4A5D' : '#3A4B6459'" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.38985 15.9466L5.30791 12.2349L3.94727 13.4721L9.38985 18.4211L21.0525 7.81621L19.6919 6.57898L9.38985 15.9466Z"
                        :fill="discipline.search && !disciplineAllSelected ? 'white' : 'transparent'" />
                  <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :stroke="discipline.search && !disciplineAllSelected ? '#9B2733' : '#3A4B64'" />
                </svg>
                <div>
                  <span>{{ discipline.title.replace('Sporty', 'Sp.') }}</span>
                  <span class="ml-1 font-light">({{ discipline.count }})</span>
                </div>
              </div>
            </div>
            <div class="flex w-full items-end mt-5 mb-2.5 xl:mb-3">
              <span class="text-xl font-medium xl:font-semibold xl:text-base">Kurs:</span>
            </div>
            <div class="flex justify-start gap-x-10 gap-y-[15px] flex-col text-sm xl:gap-y-2 xl:text-base xl:flex-row">
              <div
                  @click="odds.min = 0; odds.max = 999; filterBets(false); calculateBetCountByCategory();"
                  class="flex gap-x-[9px] items-center cursor-pointer zt-hover">
                <div
                    class="radio_btn"
                    title="Wszystkie"
                    :class="{ 'radio_btn_checked' : odds.min === 0 && odds.max === 999 }">
                </div>
                <span class="font-normal">Wszystkie</span>
              </div>

              <div
                  @click="odds.min = 0; odds.max = 1.99; filterBets(false); calculateBetCountByCategory();"
                  class="flex gap-x-[9px] items-center cursor-pointer zt-hover">
                <div class="radio_btn"
                     :class="{ 'radio_btn_checked' : odds.min === 0 && odds.max === 1.99 }"
                     title="< 2.00"
                     >
                </div>
                <span class="font-normal">Poniżej 2.0</span>
              </div>

              <div
                  @click="odds.min = 2; odds.max = 999; filterBets(false); calculateBetCountByCategory();"
                  class="flex gap-x-[9px] items-center cursor-pointer zt-hover">
                <div class="radio_btn min-w-5 xl:min-w-[25px]"
                     :class="{ 'radio_btn_checked' : odds.min === 2 && odds.max === 999 }"
                     title="< 2.00"
                     >
                </div>
                <span class="font-normal">2.0 i wyżej</span>
              </div>
            </div>
            <div class="flex w-full items-end mt-5 mb-2.5 xl:mb-3">
              <span class="text-xl font-medium xl:font-semibold xl:text-base">Inne</span>
            </div>
            <div class="form-check flex justify-between items-center form-switch font-normal mb-4 text-sm xl:text-base">
              <label class="inline-block mr-3 max-w-[400px] xl:w-full" for="only-not-played">Pokaż tylko nadchodzące wydarzenia</label>
              <input :checked="showOnlyNotPlayedYet"
                     @click="toggleOnlyNotPlayedYet()"
                     class="form-check-input appearance-none w-[50px] rounded-full float-left h-7 bg-no-repeat
                       border border-gray-400 bg-[#1A222D] cursor-pointer shadow-sm focus:outline-none checked:bg-zt-red checked:border-zt-red"
                     type="checkbox" role="switch" id="only-not-played" />
            </div>
            <div class="form-check flex justify-between flex-wrap items-center form-switch font-normal text-sm xl:text-base"
                 :class="{ 'opacity-60': !isLoggedIn() }">
              <div class="flex flex-col">
                <label class="inline-block mr-3 w-[230px] xl:w-auto" for="only-followed">Pokaż typy tylko od moich obserwowanych</label>
                <span v-if="!isLoggedIn()" class="text-[14px]">(opcja tylko zalogowanych)</span>
              </div>
              <input :checked="showOnlyFollowedUsers"
                     @click="toggleOnlyFollowedUsers()"
                     class="form-check-input appearance-none w-[50px] rounded-full float-left h-7 bg-no-repeat
                       border border-gray-400 bg-[#1A222D] cursor-pointer shadow-sm focus:outline-none checked:bg-zt-red checked:border-zt-red"
                     type="checkbox" role="switch" id="only-followed" :disabled="!isLoggedIn()" />
            </div>
          </div>
          <div class="border-t border-zt-light flex justify-center rounded-b-zt py-3 xl:py-5">
            <button @click="toggleFilter(); unblockScrolling(); filterBets(true);"
                    class="py-3 zt-button bg-zt-red !shadow-none block mx-auto uppercase hover:bg-[#FF6474] w-[180px] xl:w-[333px]">
              Pokaż
            </button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import { countClicks } from '../../../assets/js/utils';
import {Notice} from "../../../assets/js/Notice";

export default {
  name: 'BetFilterModal',
  inject: ['WP'],
  mixins: [utils_mixin],
  emits: ['togglefilter', 'clearfilters', 'filterbets', 'togglediscipline', 'calculatebetcountbycategory', 'toggleOnlyNotPlayedYet', 'toggleOnlyFollowedUsers'],
  props: {
    selectedFilterCategoryCount: Number,
    odds: Object,
    disciplineAllSelected: Boolean,
    showOnlyFollowedUsers: Boolean,
    showOnlyNotPlayedYet: Boolean,
    allBetsCount: Number,
    disciplines: Array
  },
  data() {
    return {
      userCanAddCommentTypeBet: false,
    };
  },
  computed: {},
  mounted() {
    this.userCanAddCommentTypeBet = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor';

    this.emitter.on('changeTDFiltering', (discipline) => {
      if (this.selectedFilterCategoryCount === 0) {
        this.addInternalNotification(new Notice().setContent('Wybrałeś szybkie filtrowanie'));
      }
      this.toggleDiscipline(discipline);
      this.filterBets(true);
      this.scrollToSmoothly(0);
    })
  },
  methods: {
    toggleFilter() {
      this.$emit('togglefilter');
    },
    clearFilters() {
      this.$emit('clearfilters');
    },
    filterBets(saveFilters) {
      this.$emit('filterbets', saveFilters);
    },
    toggleDiscipline(discipline) {
      countClicks('Analityka Filtrowania TD - dyscypliny', 'bets');
      this.$emit('togglediscipline', discipline);
    },
    toggleOnlyNotPlayedYet() {
      countClicks('Analityka Filtrowania TD - tylko nadchodzące', 'bets');
      this.$emit('toggleOnlyNotPlayedYet');
    },
    toggleOnlyFollowedUsers() {
      countClicks('Analityka Filtrowania TD - tylko obserwowani', 'bets');
      this.$emit('toggleOnlyFollowedUsers');
    },
    calculateBetCountByCategory() {
      countClicks('Analityka Filtrowania TD - kursy', 'bets');
      this.$emit('calculatebetcountbycategory');
    }
  }
};
</script>

<style scoped>
.filter-panel::before{
  content:  '';
  position: absolute;
  top: -20px;
  left:0;
  width: 320px;
  height: 28px;
  background: #263042;
  clip-path: path('M 0 0 L 302 0 C 303 9 303 20 321 20 L 321 22 L 0 21 z');
}
.filter-panel-scroll::-webkit-scrollbar {
  display: none;
}

.filter-panel-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.radio_btn {
  @apply relative bg-zt-light/35 border transition-all border-zt-light cursor-pointer zt-hover;
  @apply rounded-full h-5 w-5 after:content-[''] xl:w-[25px] xl:h-[25px];
}
.radio_btn_checked {
  @apply bg-zt-red border-[#9B2733] after:bg-white after:w-[11px] after:h-[11px] after:xl:w-[17px] after:xl:h-[17px] after:rounded-full after:absolute after:top-1/2 after:-translate-y-1/2 after:left-1/2 after:-translate-x-1/2
}
</style>